import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSafeMode } from "@/lib/safeMode";

// Detect ?app=1 (Google Play WebView app) before first render so the whole
// UI starts in safe-content mode when needed.
initSafeMode();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
